import PropTypes from 'prop-types'
import { useContext, useEffect } from 'react'
import Router from 'next/router'
import { useTranslation } from 'next-i18next'

// Context
import { AppContext } from '../../context/AppContext'
import { ModalContext } from '../../context/ModalContext'

// Internal components
import Button from '../Button/Button'
import Svg from '../Svg/Svg'
import { UserContext } from '../../context/UserContext'

const FormPrompt = (props) => {
  const { promptHeading, promptText, confirmLabel, declineLabel } = props

  const userContext = useContext(UserContext)

  // Translations
  const { t } = useTranslation(
    userContext?.userSession?.sportType?.slug ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_NAMESPACE ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_SPORT
  )

  // Context
  const modalContext = useContext(ModalContext)
  const appContext = useContext(AppContext)

  const closeModalOnPromptConfirm = () => {
    modalContext.setModalHasPrompt(false)
    modalContext.setModalIsActive(false)
    modalContext.setModalPrompt(false)
    modalContext.setModalIsDirty(false)

    if (modalContext.modalPromptRedirect) {
      if (!appContext.isNativeApp) {
        // Open link in a new window and unset the redirect link.
        const newWindow = window.open(modalContext.modalPromptRedirect, '_blank', 'noopener,noreferrer')
        if (newWindow) newWindow.opener = null
        modalContext.setModalPromptRedirect(false)
        return
      }
      // Redirect to the page, unset the redirect link.
      Router.push(modalContext.modalPromptRedirect)
      modalContext.setModalPromptRedirect(false)
    }
  }

  // Close the prompt
  const closePromptOnDecline = () => {
    modalContext.setModalPromptRedirect(false)
    modalContext.setModalHasPrompt(false)
  }

  useEffect(() => {
    if (modalContext.modalHasPrompt) modalContext.setModalScrollTop(true)
  }, [modalContext.modalHasPrompt])

  return (
    <>
      {modalContext.modalHasPrompt && (
        <>
          <div className="FormPrompt-promptOverlay" onClick={() => closePromptOnDecline()}></div>
          <div className="FormPrompt">
            {promptHeading && (
              <h4 className="FormPrompt-heading">
                {!modalContext.modalPromptRedirect ? t(promptHeading.default) : t(promptHeading.alt)}
              </h4>
            )}
            {promptText && (
              <div className="FormPrompt-body">
                <p>{!modalContext.modalPromptRedirect ? t(promptText.default) : t(promptHeading.alt)}</p>
              </div>
            )}
            <div className="FormPrompt-buttonGroup">
              {declineLabel && (
                <Button
                  label={t(declineLabel)}
                  modifiers={['Button--selectDialogDecline']}
                  onClick={() => closePromptOnDecline()}
                />
              )}
              {confirmLabel && (
                <Button
                  label={!modalContext.modalPromptRedirect ? t(confirmLabel.default) : t(confirmLabel.alt)}
                  modifiers={['Button--selectDialogConfirm']}
                  onClick={() => closeModalOnPromptConfirm()}
                />
              )}
            </div>
            <div className="Modal-close" onClick={() => closePromptOnDecline()}>
              <Svg id={'icon-close'} modifiers={['Modal-closeIcon']} />
            </div>
          </div>
        </>
      )}
    </>
  )
}

FormPrompt.propTypes = {
  promptHeading: PropTypes.object,
  promptText: PropTypes.object,
  confirmLabel: PropTypes.object,
  declineLabel: PropTypes.string,
  context: PropTypes.any
}

export default FormPrompt
